import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('logs');

const state = {
  logSearchResults: [],
  currentLog: {},
};

const getters = {
  logSearchResults: (state) => state.logSearchResults,
  currentLog: (state) => state.currentLog,
};

const mutations = {
  setLogSearchResults: (state, logSearchResults) => {
    state.logSearchResults = logSearchResults;
  },
  updateLogSearchResults: (state, task) => {
    const index = state.logSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.logSearchResults, index, task);
  },
  removeFromLogSearchResults: (state, id)=>{
    state.logSearchResults.data = state.logSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.logSearchResults.total--;
  },
  setCurrentLog: (state, currentLog) => {
    state.currentLog = currentLog;
  },
};

const actions = {
  async searchLogs({commit}, query) {
    const response = await API.search(query);
    commit('setLogSearchResults', response.data);
    return response.data;
  },
  async loadLog({commit}, id) {
    const response = await API.load(id);

    commit('setCurrentLog', response.data);
    return response.data;
  },
  async createLog({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateLog({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateLogSearchResults', response.data);
    return response.data;
  },
  async deleteLog({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromLogSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
